import React from "react";

const SwitchCeles = ({ value, setValue, onClick = false }) => {
  return (
    <div
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        } else {
          setValue(!value);
        }
      }}
      className={` ${
        value ? "bg-laundry-green-swicth" : "bg-laundry-gray-swicth "
      } w-[51px] h-[31px] rounded-full shadow-sm `}
    >
      <div
        className={` ${
          value ? " translate-x-[22px]  " : "translate-x-0.5"
        } rounded-full bg-gray-50 w-[27px] h-[27px] shadowswitch translate-y-[1.7px] `}
      />
    </div>
  );
};
export default SwitchCeles;
